import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["list"]

    addRow() {
        const template = `
      <div class="flex items-center space-x-2">
        <input type="text"
               name="series[price_variants_attributes][][name]"
               placeholder="Variant name"
               class="flex-1 rounded-md border-gray-300"/>

        <input type="hidden"
               name="series[price_variants_attributes][][_destroy]"
               value="false" />

        <button type="button"
                class="text-red-600 text-xl font-bold"
                data-action="price-variants#removeRow">&times;</button>
      </div>
    `;
        this.listTarget.insertAdjacentHTML("beforeend", template);
    }

    removeRow(event) {
        const row = event.currentTarget.closest("div");
        const destroyInput = row.querySelector('input[name*="[_destroy]"]');

        if (destroyInput) {
            destroyInput.value = "1";
        }

        row.style.display = "none";
    }
}